import React, { useEffect, useState } from "react";
import { DialogBox } from "../../shared/components/dialog";
import {
  Box,
  Button,
  DialogContent,
  FormHelperText,
  Stack,
  TextField,
  Typography,
} from "@mui/material";
import { useArcAuth } from "@arcauth/react-sdk";
import { useDispatch, useSelector } from "react-redux";
import IntlTelInput from 'intl-tel-input/react';
import 'intl-tel-input/build/css/intlTelInput.css';
import { getPhoneEmailExists, getUserInfo, updateUserInfo } from "../../redux/features/user.slice";
import { RootStateType } from "../../redux/features/rootSlice";
import { phoneRegex, sixDigitOTPRegex } from "../../shared/util/authentication.regex";
import { MESSAGES, webSocketMessage } from "../../config/app";
import { getSecurityCode } from "../../redux/features/auth.slice";
import useCountdownTimer from './../../hooks/useCountdownTimer';
import { ButtonComponent } from "../../shared/components/button";
import useWebSocket from "../../hooks/useWebSocket";
export interface DialogProps {
  open: boolean;
  onClose: () => void;
  user?: {
    id: string;
    firstname: string;
    lastname: string;
    phone: string;
    email: string;
    newpassword: string;
    oldpassword: string;
    language: string;
    timezone: string;
  };
}

const errorMap = [
  'Invalid number',
  'Invalid country code',
  'Too short',
  'Too long',
  'Invalid number'
];

const PhoneUpdate = (props: DialogProps) => {
  const { open, onClose, user } = props;
  const { timeLeft, resendButtonEnabled, resetTimer } = useCountdownTimer(180); // 3 minutes
  const dispatch = useDispatch();
  const [buttonEnabled, setButtonEnabled] = useState(false);
  const [phone, setPhone] = useState("");
  const [isValidPhone, setIsValidPhone] = useState<boolean>(true);
  const [phoneHelperText, setPhoneHelperText] = useState("");
  const [phoneCode, setPhoneCode] = useState(false);
  const [securityCode, setSecurityCode] = useState("");

  const phoneUpdate_loading = useSelector(
    (state: RootStateType) => state.userStateReducer.loading
  );
  const code_loading = useSelector(
    (state: RootStateType) => state.authStateReducer.loading
  );
  const { updateUserAndNotifyParent } = useWebSocket();
  const configData: any = useSelector((state: RootStateType) => state.configStateReducer.clientConfig);
  const dialogClose = () => {
    setPhoneCode(false);
    resetTimer();
    onClose();
  };

  const reSendCode = async () => {
    const sendCodeObj = {
      body: {
        phone,
        applicationid: configData?.applicationId,
      },
      callBackSuccess: () => {
        setPhoneCode(true);
        resetTimer();
        setSecurityCode("");
        setButtonEnabled(false);
      },
      callBackFailure: () => {
        setButtonEnabled(false);
      },
    };
    dispatch(getSecurityCode(sendCodeObj));
  }

  const validatePhoneAndSendCode = async () => {
    const dispatchObj = {
      params: { phone },
      callBackSuccess: () => {
        reSendCode();
      },
      callBackFailure: () => {
        setButtonEnabled(false);
      },
    };
    dispatch(getPhoneEmailExists(dispatchObj));
  };

  const handleListItemClick = async () => {
    setPhoneCode(true);
    const dispatchObj = {
      user: {
        phone,
        code: securityCode,
        applicationid: configData?.applicationId,
      },
      successMessage: MESSAGES.phoneSuccess,
      callBackSuccess:() => {
        onClose();
        updateUserAndNotifyParent(webSocketMessage.phoneResponse);      
        setPhoneCode(false);
        setSecurityCode("");
        dispatch(getUserInfo());
        setButtonEnabled(false);
      },
      callBackFailure: () => {
        setButtonEnabled(false);
      },
    };
    dispatch(updateUserInfo(dispatchObj));
  };

  const handleKeyDown = (e: React.KeyboardEvent) => {
    if (e.key === "Enter" && buttonEnabled) {
      e.preventDefault();
      handleListItemClick();
    }
  };

  const handleKeyDownCode = (e: React.KeyboardEvent) => {
    if (e.key === "Enter" && buttonEnabled) {
      e.preventDefault();
      validatePhoneAndSendCode();
    }
  };

  useEffect(() => {
    setPhone(user?.phone ?? "");
  }, [user]);

  useEffect(() => {
    if (phone == "") {
      setButtonEnabled(false);
      setPhoneHelperText("Phone cannot be empty");
    } else {
      if (phone != user?.phone && isValidPhone) {
        setPhoneHelperText("");
        setButtonEnabled(true);
        return;
      }
      // else {
      //   setButtonEnabled(false);
      //   setPhoneHelperText("Invalid number");
      // }
      //if (phone == user?.phone) setPhoneHelperText("");
    }
  }, [phone]);

  useEffect(() => {
    if (securityCode === "") {
      setButtonEnabled(false);
      //setEmailHelperText("Email cannot be empty");
    } else if (securityCode.length === 6 && sixDigitOTPRegex.test(securityCode)) {
      setPhoneHelperText("");
      setButtonEnabled(true);
    } else {
      setButtonEnabled(false);
      // setPhoneHelperText("Invalid code");
    }
  }, [securityCode]);

  function handlePhoneChange(value: string): void {
    setPhone(value ?? "");
  }

  function handleErrorCodeChange(errorCode: number | null): void {
    console.log({ errorCode });

    if (errorCode === null || errorCode === undefined) {
      setPhoneHelperText('');
      setIsValidPhone(true);
      return;
    }

    const msg = errorMap[errorCode] || 'Invalid number';
    phone.length===0? setPhoneHelperText(''): setPhoneHelperText(msg);
    setIsValidPhone(false);
    setButtonEnabled(false);
  }

  return (
    <>
      <DialogBox
        onClose={dialogClose}
        title={"Update phone"}
        buttonText={phoneCode ? 'Update' : 'Continue'}
        buttonClick={phoneCode ? handleListItemClick : validatePhoneAndSendCode}
        isLoading={phoneCode ? phoneUpdate_loading : phoneUpdate_loading || code_loading}
        isBtnEnabled={!buttonEnabled}
        open={open}
        style={{'.MuiDialog-paper': {overflow: 'visible'}, maxWidth: 500, mx: "auto"}}
      >
        <DialogContent sx={{overflow: "visible"}}>
          <Stack>
            {!phoneCode ? (
                 <><label htmlFor="" style={{ fontSize: 13 }}>Phone number</label><Box key="uniqueKey" sx={{ '>div': { width: '100%' }, '.iti-5__dropdown-content, .iti--container': { zIndex: 9999 } }}>
                <IntlTelInput
                  initialValue={user?.phone}
                  onChangeNumber={handlePhoneChange}
                  onChangeErrorCode={handleErrorCodeChange}
                  initOptions={{
                    initialCountry: 'auto',
                    showSelectedDialCode: true,
                    formatAsYouType: true,
                    formatOnDisplay: true,
                    autoPlaceholder: 'off',
                    useFullscreenPopup: false,
                    hiddenInput: () => ({
                      phone: 'full_phone',
                      country: 'country_code'
                    }),
                    geoIpLookup: (callback) => {
                      callback(user?.phone || 'us');
                    },
                    utilsScript: 'https://d2dsx67ik4jg4k.cloudfront.net/assets/js/utils.js'
                  }}
                  inputProps={{
                    type: 'tel',

                    maxLength: 15,
                    onKeyDown: handleKeyDownCode,
                    placeholder: 'Enter phone number *',
                    style: {
                      height: '42px',
                      width: '100%',
                      borderRadius: '7px',
                      fontFamily: 'DM Sans, sans-serif',
                      fontSize: '1rem'
                    }
                  }} />
              </Box></>
            ) : null}
            {
              phoneCode ? <>

                <Typography variant="body1" color="initial" textAlign={'center'} gutterBottom>
                  Please share the 6-digit security code sent to {phone}
                </Typography>
                <label htmlFor="">Security code</label>
                <TextField
                  size="small"
                  fullWidth
                  autoFocus
                  // label="Security code"
                  value={securityCode ?? ""}
                  placeholder="Enter security code"
                  color="secondary"
                  inputProps={{ maxLength: 6 }}
                  onKeyDown={handleKeyDown}
                  onChange={(e) => {
                    setSecurityCode(e.target.value);
                  }}
                />
                <Stack direction={'row'} justifyContent={"space-between"} alignItems="center">
                  <Box>{timeLeft}</Box>
                  <ButtonComponent
                    buttonName="Resend"
                    variant="text"
                    color="secondary"
                    onClickHandle={() => {
                      resetTimer();
                      reSendCode();
                    }}
                    isBtnEnabled={!resendButtonEnabled}
                    isLoading={code_loading}
                  />
                </Stack>
              </> : null
            }
            <FormHelperText style={{ color: "red", fontSize: '12px' }}>
              {phoneHelperText}
            </FormHelperText>
          </Stack>
        </DialogContent>
      </DialogBox>
    </>
  );
};

export default PhoneUpdate;
